import { composeIO } from 'react-compose-io'
import { regraTransformacaoIO } from './RegraTransformacao.IO'
import { RegraTransformacaoView } from './RegraTransformacao.View'

export const RegraTransformacao = composeIO(RegraTransformacaoView, regraTransformacaoIO)
